import { Button } from '@cian/ui-kit/button';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './ListingMobileFooter.css';

export interface IListingMobileFooterProps {
  onPrevClick(): void;
  onNextClick(): void;
  onScrollTopClick(): void;
  hasPrev: boolean;
  hasNext: boolean;
  isLoading: boolean;
  className?: string;
}

export const ListingMobileFooter: React.FC<IListingMobileFooterProps> = ({
  onPrevClick,
  onNextClick,
  onScrollTopClick,
  hasPrev,
  hasNext,
  isLoading,
  className,
}) => {
  return (
    <div data-testid="ListingMobileFooter" className={cn(styles['root'], className)}>
      <Button
        onClick={onNextClick}
        theme="stroke_primary"
        fullWidth
        disabled={!hasNext || isLoading}
        loading={isLoading}
      >
        Дальше
      </Button>
      <Button
        onClick={onPrevClick}
        theme="stroke_primary"
        fullWidth
        disabled={!hasPrev || isLoading}
        loading={isLoading}
      >
        Назад
      </Button>
      <Button onClick={onScrollTopClick} theme="stroke_secondary" fullWidth>
        Вернуться наверх
      </Button>
    </div>
  );
};

ListingMobileFooter.displayName = 'ListingMobileFooter';
